var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TaskFilter'),_c('BaseCountCard',{staticStyle:{"margin-top":"18px"}}),_c('DevTaskTrend',{staticStyle:{"margin-top":"18px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }